import { hasAnyPermission, hasPermission } from "@/constants";
import { useSessionStore } from "@/store";

/**
 * Joriy foydalanuvchining ruxsatlari.
 *
 * Sessiya do'konidan o'qiydi — `/auth/me` javobi bilan birga keladi va
 * qo'shimcha so'rov qilinmaydi. Ruxsat o'zgarsa, keyingi `/auth/me` da
 * yangilanadi; backend esa har so'rovda bazadan tekshiradi, ya'ni
 * eskirgan brauzer holati hech narsani ochib bermaydi.
 */
export function useCan() {
  const user = useSessionStore(state => state.user);

  return {
    /** Bitta ruxsat. */
    can: (permission: string) => hasPermission(user, permission),
    /** Ro'yxatdagilardan bittasi yetarli (OR). */
    canAny: (permissions: string[]) => hasAnyPermission(user, permissions),
    isSuperadmin: Boolean(user?.isSuperadmin),
  };
}
